import { Dispatch, SetStateAction, useState } from 'react';
import { BucketLogData, formattingLogData } from '@bucketplace/bucket-log';

import { useEditorInfoContext } from '../contexts';
import { useIntersectionObserver } from './useIntersectionObserver';

interface UseImpressionLogProps {
  logData?: BucketLogData;
  threshold?: number;
  disable?: boolean;
}

interface UseImpressionLog<T extends HTMLElement> {
  ref: Dispatch<SetStateAction<T | null>>;
}

export function useImpressionLog<T extends HTMLElement>({
  logData,
  threshold,
  disable,
}: UseImpressionLogProps): UseImpressionLog<T> {
  const [ref, setRef] = useState<T | null>(null);
  const { onSendLog } = useEditorInfoContext();

  const sendImpressionLog = (): void => {
    if (isIntersecting && !disable && !!logData) {
      const { category, ...others } = logData;

      onSendLog?.({
        category: 'impression',
        data: [
          {
            ...formattingLogData(others),
            time: Date.now(),
          },
        ],
      });
    }
  };

  const isIntersecting = useIntersectionObserver({
    target: ref,
    options: {
      threshold,
    },
    onIntersect: sendImpressionLog,
  });

  return {
    ref: setRef,
  };
}
